import React, { useRef, useEffect, useState } from 'react';
import './style.css';

function Button( props ) {
    
    const [ active, setActive ] = useState( false );
    const btnEle = useRef( null );

    useEffect(() => {
        let menu = btnEle.current.nextElementSibling;   
        
        window.addEventListener( 'click', e => {
            if( !active || e.target === btnEle.current ) return;
            if( !isDescendant( menu, e.target ) ) btnEle.current.parentNode.classList.remove( 'open' );
        });
    });

    /** 
     * @name isDescendant
     * @param {HTMLElement} child
     * @returns {boolean} 
     * @description determines if the click occurred inside the menu or not
    */
   const isDescendant = ( parent, child ) => {
    let node = child.parentNode;

    while (node != null) {
        if( node === parent ) return true;
        node = node.parentNode;
    }
    return false;
    }

    /** 
     * @name handleClick
     * @param {Object} e Browser event object 
     * @returns {boolean} 
     * @description determines toggle menu
    */
    const handleClick = e => {
        e.preventDefault();
        e.stopPropagation();
        syncDropdown( e.target.id );
        if( props.callback ) return props.callback( props.label, btnEle );
        btnEle.current.parentNode.classList.toggle( 'open' );
        setActive( true );
    }

    /** 
     * @name syncDropdown
     * @param {String} e id of current dropdown 
     * @description open Dropdown one at a time
    */
    const syncDropdown = ( id ) => {
        switch( id ){
            case 'year':
                document.querySelector('#sort').parentNode.classList.remove('open');
                break;
            case 'sort':
                document.querySelector('#year').parentNode.classList.remove('open');
                break;
            default: 
                break;
        }
    }

    return (        
            <span id={ props.id } 
                onClick={ handleClick }
                ref={ btnEle }
                className="btn btn-default">
                    { props.icon ? <i className="fas fa-angle-down" /> : null }
                    { props.label + ' ' }
            </span>
        
    )
}

export default Button
